import React from "react";
import { createGlobalStyle } from "styled-components";
import Header from "../header";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "axios";
import { apiCall_domain } from "../api";
import Spinner from "../Spinner/Spinner";
class myRequest extends React.Component {
  state = {
    VendorHeader: true,
    handelPushHomePage: true,
    ordersArchive: [],
    orders: [],
    loading: true,
  };
  componentDidMount() {
    const Headers2 = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/mechanics/orders?status="active"`, {
        headers: Headers2,
      })
      .then((res) => {
        this.setState({ orders: res.data.data, loading: false });
      });
    axios
      .get(`${apiCall_domain}/customer/mechanics/orders?status="archived"`, {
        headers: Headers2,
      })
      .then((res) => {
        this.setState({ ordersArchive: res.data.data });
      });
  }
  pushOrderDetails(id, is_request) {
    localStorage.setItem("serviceUserOrdersDetailsd", id);
    localStorage.setItem("serviceUseris_request", is_request);
    this.props.history.push({
      pathname: "/multiVendor/myRequest/OrderDetails",
    });
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <Header
              showSearchBar={true}
              title={"خدمات من"}
              VendorHeader={this.state.VendorHeader}
              handelPushHomePage={this.state.handelPushHomePage}
            />
            <GlobalStyles />
            <div className="tabsCompCategoryDetails myOrderComMultiVendorTabs">
              <Tabs>
                <TabList>
                  <Tab>جاری</Tab>
                  <Tab>آرشیو</Tab>
                </TabList>
                <TabPanel index={0}>
                  {this.state.orders.length == 0 ? (
                    <div className="noGarage noREQ">
                      لیست سفارشات جاری شما خالی است
                    </div>
                  ) : (
                    this.state.orders.map((item) => (
                      <div className="myOrderComMultiVendor">
                        <div className="Txt">{item.garage.name}</div>
                        <div className="myOrderRow">
                          <img
                            src="/public/assets/icons/ServiceMulti.svg"
                            alt="pic"
                          />
                          <span>
                            {item.type == "dynamic"
                              ? "سرویس دهی سیار"
                              : item.type == "static"
                                ? "سرویس دهی ثابت"
                                : item.type == "both"
                                  ? "سرویس دهی ثابت و سیار"
                                  : ""}
                          </span>
                        </div>
                        <div className="myOrderRow">
                          <img
                            src="/public/assets/icons/locationMulti.svg"
                            alt="pic"
                          />
                          <span>
                            {item.address !== null ? item.address.address : ""}
                          </span>
                        </div>
                        <div className="myOrderRow">
                          <img
                            src="/public/assets/icons/timeMulti.svg"
                            alt="pic"
                          />
                          <span>{item.full_time}</span>
                        </div>
                        {item.is_request == true ? (
                          <></>
                        ) : (
                          <div className="myOrderRow">
                            <img
                              src="/public/assets/icons/priceMulti.svg"
                              alt="pic"
                            />
                            <span className="totalPrice">هزینه کل : </span>
                            <span> {item.final_price}</span>
                          </div>
                        )}
                        <div className="Condition">
                          <div className="ConditionRight">
                            <span className="firstChild">وضعیت :</span>
                            <span className="lastChild">{item.status}</span>
                          </div>
                          <div
                            className="Details"
                            onClick={() =>
                              this.pushOrderDetails(item.id, item.is_request)
                            }
                          >
                            <span>جزئیات</span>
                            <img
                              src="/public/assets/icons/leeeft.svg"
                              alt="pic"
                            />
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </TabPanel>
                <TabPanel index={0}>
                  {this.state.ordersArchive.length == 0 ? (
                    <div className="noGarage">
                      لیست سفارشات آرشیو شما خالی است
                    </div>
                  ) : (
                    this.state.ordersArchive.map((item) => (
                      <div className="myOrderComMultiVendor">
                        <div className="Txt">{item.garage.name}</div>
                        <div className="myOrderRow">
                          <img
                            src="/public/assets/icons/ServiceMulti.svg"
                            alt="pic"
                          />
                          <span>
                            {item.type == "dynamic"
                              ? "سرویس دهی سیار"
                              : item.type == "static"
                                ? "سرویس دهی ثابت"
                                : item.type == "both"
                                  ? "سرویس دهی ثابت و سیار"
                                  : ""}
                          </span>
                        </div>
                        <div className="myOrderRow">
                          <img
                            src="/public/assets/icons/locationMulti.svg"
                            alt="pic"
                          />
                          <span>
                            {item.address !== null ? item.address.address : ""}
                          </span>
                        </div>
                        <div className="myOrderRow">
                          <img
                            src="/public/assets/icons/timeMulti.svg"
                            alt="pic"
                          />
                          <span>{item.full_time}</span>
                        </div>
                        {item.is_request == true ? (
                          <></>
                        ) : (
                          <div className="myOrderRow">
                            <img
                              src="/public/assets/icons/priceMulti.svg"
                              alt="pic"
                            />
                            <span className="totalPrice">هزینه کل : </span>
                            <span className="PriceValue">
                              {item.final_price}
                            </span>
                          </div>
                        )}
                        <div className="Condition">
                          <div className="ConditionRight">
                            <span className="firstChild">وضعیت :</span>
                            <span className="lastChild">{item.status}</span>
                          </div>
                          <div
                            className="Details"
                            onClick={() => this.pushDetails(item.id)}
                          >
                            <span>جزئیات</span>
                            <img
                              src="/public/assets/icons/leeeft.svg"
                              alt="pic"
                            />
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </TabPanel>
              </Tabs>
            </div>
          </>
        )}
      </>
    );
  }
}
export default myRequest;
